export default __webpack_public_path__ + "ef420559f4952f516ac42e015c359e4c.ttf";